import { render, staticRenderFns } from "./ed-portal-info-section-title.vue?vue&type=template&id=0f29126e&scoped=true&"
import script from "./ed-portal-info-section-title.ts?vue&type=script&lang=js&"
export * from "./ed-portal-info-section-title.ts?vue&type=script&lang=js&"
import style0 from "./ed-portal-info-section-title.scss?vue&type=style&index=0&id=0f29126e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29126e",
  null
  
)

export default component.exports